import { ComputedRef } from 'vue';

import * as API from '../requests';
import useLiveMarketDepthQueryFactory from './useLiveMarketDepthQueryFactory';
import { SYMBOL_QUERY_KEYS } from '../constants';

type useLiveSellMarketDepthQueryConfigs = {
  isin: ComputedRef<string | null>;
  exchangeCode: ComputedRef<string | null>;
};

export default function useLiveSellMarketDepthQuery({
  isin,
  exchangeCode,
}: useLiveSellMarketDepthQueryConfigs) {
  const {
    execute: getSellMarketDepth,
    result: sellMarketDepth,
    isLoadingMarketDepth: isLoadingSellMarketDepth,
    isRevalidatingMarketDepth: isRevalidatingSellMarketDepth,
    isErrorMarketDepth: isErrorSellMarketDepth,
    marketDepthStatus: sellMarketDepthStatus,
  } = useLiveMarketDepthQueryFactory({
    immediate: true,
    type: 2,
    isin: isin,
    key: SYMBOL_QUERY_KEYS.sellMarketDepth(isin),
    sorter: (a, b) => a - b,
    fetcher: () =>
      API.getSellMarketDepth({
        isin: isin.value,
        exchangeCode: exchangeCode.value,
      }),
  });

  return {
    sellMarketDepth,
    getSellMarketDepth,
    isLoadingSellMarketDepth,
    isRevalidatingSellMarketDepth,
    isErrorSellMarketDepth,
    sellMarketDepthStatus,
  };
}
